<template>
  <div
    ref="scrollContainer"
    class="shop-screen"
    @scroll.passive="loadNextOnScroll"
  >
    <header class="shop-header">
      <button
        class="back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ title || $t('shop.experienceProducts') }}</h1>
    </header>
    <main>
      <van-list
        v-if="!empty"
        v-model="loading"
        :finished="!hasMore"
        finished-text=""
        :loading-text="$t('utils.loading')"
        @load="load"
      >
        <section class="product-grid">
          <button
            v-for="item in list"
            :key="item.id"
            class="product-card"
            @click="open(item.id)"
          >
            <img
              :src="item.image"
              :alt="item.title"
            >
            <span class="product-title">{{ item.title }}</span>
            <span class="product-price">{{ money(item.price) }}</span>
            <del v-if="item.market_price">{{ money(item.market_price) }}</del>
          </button>
        </section>
      </van-list>
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
    </main>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';
import Vue from 'vue';
import { Empty, List } from 'vant';

Vue.use(Empty).use(List);

export default {
    data() {
        return { list: [], page: 1, hasMore: true, loading: false, requesting: false, empty: false, title: '' };
    },
    mounted() {
        this.$parent.footer('index', true);
        this.title = this.$route.query.title || '';
        document.body.classList.add('good-list-page');
        this.load();
    },
    beforeDestroy() {
        document.body.classList.remove('good-list-page');
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        load() {
            if (this.requesting || !this.hasMore) {
                this.loading = false;
                return;
            }
            this.requesting = true;
            this.loading = true;
            Fetch('/shop/products', {
                class_id: this.$route.query.class_id || '',
                page: this.page,
                page_size: 20
            }).then((res) => {
                const pageList = res.data.list || [];
                this.list = this.list.concat(pageList);
                this.hasMore = !!res.data.has_more && pageList.length > 0;
                this.empty = this.list.length === 0;
                this.page += 1;
            }).finally(() => {
                this.requesting = false;
                this.loading = false;
                this.$nextTick(() => this.loadNextOnScroll());
            });
        },
        loadNextOnScroll() {
            const container = this.$refs.scrollContainer;
            if (!container) {
                return;
            }
            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 160) {
                this.load();
            }
        },
        open(id) {
            this.$router.push('/good/' + id);
        }
    }
};
</script>

<style>
body.good-list-page { background-image: none; background-color: #f5f5f5; }
</style>

<style scoped>
.shop-screen { box-sizing: border-box; height: 100vh; overflow-y: auto; -webkit-overflow-scrolling: touch; background: #f5f5f5; color: #333; padding-bottom: calc(var(--app-bottom-menu-height) + 16px + env(safe-area-inset-bottom, 0px)); }
.shop-header { height: 50px; display: flex; align-items: center; justify-content: center; position: relative; background: #fff; border-bottom: 1px solid #f1f1f1; }
.shop-header h1 { margin: 0; font-size: 16px; font-weight: 500; }
.back { position: absolute; left: 16px; border: 0; background: transparent; font-size: 18px; color: #ee4d2d; }
.product-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; padding: 10px; }
.product-card { overflow: hidden; padding: 0 0 10px; border: 1px solid #eee; border-radius: 0; background: #fff; text-align: left; color: #333; }
.product-card img { display: block; width: 100%; height: 164px; object-fit: contain; background: #fff; }
.product-title { display: -webkit-box; min-height: 32px; margin: 9px 10px 3px; overflow: hidden; font-size: 12px; line-height: 16px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.product-price { display: block; margin: 0 10px 2px; font-size: 14px; color: #ee4d2d; }
del { display: block; margin: 0 10px; color: #9098a2; font-size: 12px; }
</style>
